'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
require('./svg-icon-501cae97.js');
var close = require('./close-40bc5458.js');
var MaterialDialogTitle = _interopDefault(require('@material-ui/core/DialogTitle'));

var StyledTitle = styled__default(MaterialDialogTitle)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  &.root {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 28px;\n    color: ", ";\n    font-family: ", ";\n    margin-top: 32px;\n    margin-left: 32px;\n    padding: 0px;\n  }\n"], ["\n  &.root {\n    font-style: normal;\n    font-weight: 500;\n    font-size: 24px;\n    line-height: 28px;\n    color: ", ";\n    font-family: ", ";\n    margin-top: 32px;\n    margin-left: 32px;\n    padding: 0px;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts[1];
});
var StyledCloseIcon = styled__default(close.Close)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  position: absolute;\n  right: 13px;\n  top: 13px;\n  color: ", ";\n"], ["\n  position: absolute;\n  right: 13px;\n  top: 13px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var DialogTitle = function (_a) {
    var onClose = _a.onClose, title = _a.title, dataCy = _a.dataCy, restProps = tslib_es6.__rest(_a, ["onClose", "title", "dataCy"]);
    return (React__default.createElement(StyledTitle, tslib_es6.__assign({ disableTypography: true, "data-cy": dataCy + "-dialog-title", classes: {
            root: 'root',
        }, id: "dialog-slide" }, restProps),
        title,
        onClose ? (React__default.createElement(StyledCloseIcon, { "data-cy": dataCy + "-close-icon", onClick: onClose, size: "sm" })) : null));
};
var templateObject_1, templateObject_2;

exports.DialogTitle = DialogTitle;
